import React from 'react';
import { Card as SCard, Icon, Button } from 'semantic-ui-react';
import { Card } from './Card';

export const CardSongCycle = ({data, id}) => {
  console.log("card song", data);
  const title = data.versions[0].song_cycle_version.title;

  const header = (
    <React.Fragment>
      {title}
    </React.Fragment>
  );

  const meta = (
    <React.Fragment>
      {data.composer.first_name} {data.composer.last_name}
    </React.Fragment>
  );

  const extra = (
    <React.Fragment>
      <SCard.Content extra>
        <Button floated='right' size='mini' >Buy Now</Button>
        <Icon name='music' />
        datasongslength {/* datasongslngth{data.songs.length} */}
      </SCard.Content>
    </React.Fragment>
  )

  return (
    <Card model='song_cycles' header={header} meta={meta} id={data.song_cycle.id} extra={extra} color='yellow'>
    </Card>
  );
};